
export default {
  props: {
    itemId: {
      type: [String, Number],
      required: true,
    },
    tryForFree: {
      type: Boolean,
      default: false,
    },
    premium: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTooltip: null,
      compareShow: false,
      pricingTable: true,
      options: [
        {
          name: "subtitle",
          label: "Subtitle",
          type: "checkbox",
        },
        {
          name: "label",
          label: "label",
          type: "text",
        },
        {
          name: "tooltip",
          label: "Podnaslov",
          type: "tipTap",
        },
        {
          name: "value1",
          label: "Value1",
          type: "text",
        },
        {
          name: "value2",
          label: "Value2",
          type: "text",
        },
        {
          name: "value3",
          label: "Value3",
          type: "text",
        },
        {
          name: "value4",
          label: "Value4",
          type: "text",
        },
        {
          name: "check",
          label: "Check",
          type: "checkbox",
        },
      ],
      tableOption: [
        {
          name: "title",
          label: "Naziv usluge",
          type: "text",
        },
        {
          name: "tooltip",
          label: "Tooltip usluge (Ako je prazan nece biti prikazan)",
          type: "textarea",
        },
        {
          name: "basic",
          label:
            "Value basic (Ako je prazno bit ce crtica, ako se napise YES bit ce kvačica)",
          type: "text",
        },
        {
          name: "advanced",
          label:
            "Value advanced (Ako je prazno bit ce crtica, ako se napise YES bit ce kvačica)",
          type: "text",
        },
        {
          name: "professional",
          label:
            "Value professional (Ako je prazno bit ce crtica, ako se napise YES bit ce kvačica)",
          type: "text",
        },
        {
          name: "enterprise",
          label:
            "Value enterprise (Ako je prazno bit ce crtica, ako se napise YES bit ce kvačica, ako je neka druga rijec bit ce prazno)",
          type: "text",
        },
      ],
      premiumOptions: [
        {
          name: "title",
          label: "Naziv usluge",
          type: "text",
        },
      ],
    };
  },
};
